import "./NotificationList.scss";
import { useState, useEffect } from "react";
// import DummyNotifs from "./dummyNotifs.json";
import SingleNotif from "../singleNotif/SingleNotif";
import FilterHeader from "./filterHeader/FilterHeader";
import { useContext } from "react";
import { NotifContext } from "../context/notifContext";
import {
  activeFiltering,
  getNotifsCount,
  particulateNotifCategory,
} from "./filters";
import { Checkbox, Input, message, Popconfirm, Skeleton } from "antd";
import { API } from "aws-amplify";
import { useAuth } from "../../../../../authentication/authHelpers";
import { useSelector } from "react-redux";
import { UnfoldIcon } from "../../../../../assets/icons";
import { requestDataWithParams } from "../../../../../helpers/API/RequestFactory";

function NotificationList({
  notifsType,
  activeFilter,
  processActiveFilter,
  countNotifs,
  handleCancel,
}) {
  let auth = useAuth();
  const { isDarkMode } = useSelector((state) => state.usersList);

  const { dispatch, isFetching, notificationsArr } = useContext(NotifContext);

  const [notifs, setNotifs] = useState(notificationsArr);
  const [pagination, setPagination] = useState({ head: 0, tail: 20 });
  const [multiCheck, setMultiCheck] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [filterActive, setFilterActive] = useState(false);

  async function loadNotifications() {
    const idObj =
      auth?.userRole === "Employee"
        ? {
            filterKey: "userDetails",
            filterValue: auth?.user?.identityId,
          }
        : null;
    await requestDataWithParams("notifications", null, null, idObj).then(
      (notifs) =>
        dispatch({
          type: "LOAD_NOTIFS",
          payload: notifs.map((el) => ({
            ...el,
            identityId: auth?.user?.identityId,
            ...(el?.userDetails[auth?.user?.identityId] || {}),
          })),
        }),
      (err) => console.error("error loading notifs", err)
    );
  }

  // Marks Notification as Read
  async function markRead(notifID, notifContent) {
    dispatch({ type: "MARK_READ", payload: notifID });
    let userD = notifContent.userDetails;
    userD[auth?.user.identityId].notificationMarkedRed = true;
    await API.put("notifications", `/notifications/${notifID}`, {
      body: {
        userDetails: {
          ...userD,
        },
      },
    }).then((res) => console.log("marked read", res));
  }

  // Marks Notification as Read
  async function markUnRead(notifID, notifContent) {
    dispatch({ type: "MARK_UNREAD", payload: notifID });
    let userD = notifContent.userDetails;
    userD[auth?.user.identityId].notificationMarkedRed = false;
    await API.put("notifications", `/notifications/${notifID}`, {
      body: {
        userDetails: {
          ...userD,
        },
      },
    }).then((res) => console.log("marked read", res));
  }

  // Marks Notification as Read/Unread toggle
  async function toggleRead(notifID, markedRead, notifContent) {
    dispatch({ type: "TOGGLE_READ", payload: notifID });
    let userD = notifContent.userDetails;
    userD[auth?.user.identityId].notificationMarkedRed = !markedRead;
    await API.put("notifications", `/notifications/${notifID}`, {
      body: {
        userDetails: {
          ...userD,
        },
      },
    }).then((res) => console.log("marked read", res));
  }
  //Marks Notification as Hidden
  async function hideNotif(notifID, markedHidden, notifContent) {
    dispatch({ type: "HIDE_NOTIF", payload: notifID });
    let userD = notifContent.userDetails;
    userD[auth?.user.identityId].notificationMarkedHidden = !markedHidden;
    await API.put("notifications", `/notifications/${notifID}`, {
      body: {
        userDetails: {
          ...userD,
        },
      },
    }).then((res) => console.log("marked read", res));
  }
  // Marks the specified Notification as deleted
  async function deleteNotif(notifID, notifContent) {
    dispatch({ type: "DELETE_NOTIF", payload: notifID });
    let userD = notifContent.userDetails;
    userD[auth?.user.identityId].notificationMarkedDeleted = true;
    await API.put("notifications", `/notifications/${notifID}`, {
      body: {
        userDetails: {
          ...userD,
        },
      },
    }).then(
      // () => console.log("delete notif"),
      () => message.success("Njoftimi u fshi me sukses!")
      // () => message.error("Ndodhi nje problem")
    );
  }

  const multiHide = async () => {
    multiCheck?.forEach(async (check) => {
      await hideNotif(
        check?.notificationId,
        check?.notificationMarkedHidden,
        check
      );
      // message.success("Success ");
    });
    setMultiCheck([]);
  };

  const multiDelete = async () => {
    await Promise.all(
      multiCheck?.map(async (check) => {
        let userD = check?.userDetails;
        userD[auth?.user.identityId].notificationMarkedDeleted = true;
        await API.put(
          "notifications",
          `/notifications/${check?.notificationId}`,
          {
            body: {
              userDetails: {
                ...userD,
              },
            },
          }
        );
      })
    )
      .then(() => {
        const filterIds = multiCheck?.map((el) => el?.notificationId);
        const remainingNotifs = notifs?.filter(
          (el) => !filterIds?.includes(el?.notificationId)
        );
        setNotifs(remainingNotifs);
        dispatch({ type: "MULTI_DELETE", payload: remainingNotifs });
        message.success("Njoftimet u fshinë me sukses!");
      })
      .catch((err) => console.log(err));
    setMultiCheck([]);
  };

  const multiMarkRead = async () => {
    multiCheck?.forEach(async (check) => {
      await markRead(check?.notificationId, check);
      // message.success("Success ");
    });
    setMultiCheck([]);
  };

  const multiMarkUnread = async () => {
    multiCheck?.forEach(async (check) => {
      await markUnRead(check?.notificationId, check);
    });
    setMultiCheck([]);
  };

  const onPagination = () => {
    let tempLen = notifs.length;
    if (tempLen > pagination.tail) {
      if (tempLen - pagination.tail > 20) {
        setPagination((prev) => ({ ...prev, tail: pagination.tail + 20 }));
      } else {
        setPagination((prev) => ({ ...prev, tail: notifs.length }));
      }
    }
  };

  const onAddCheck = (e, n) => {
    if (e) {
      let toTemp = new Set([...multiCheck, { ...n }]);
      setMultiCheck([...toTemp]);
    } else if (!e) {
      let temp = multiCheck.filter(
        (el) => el?.notificationId !== n?.notificationId
      );
      setMultiCheck(temp);
    }
  };

  const selectAll = () => {
    setMultiCheck(notifs?.slice(pagination.head, pagination.tail));
  };

  const onSearchCard = (e) => {
    let substring = e.target.value;
    if (substring !== "" && !!substring) {
      let filteredData = notifs?.filter(
        (item) =>
          item.notificationTitle.toLowerCase().includes(substring.toLowerCase())
        //   item.notificationTitle.toLowerCase().includes(substring.toLowerCase())
      );
      setSearchTerm(filteredData);
      setFilterActive(true);
    } else {
      setSearchTerm(null);
      setFilterActive(false);
    }
  };

  // Filtering of Notifications
  useEffect(() => {
    let particulate = particulateNotifCategory(notifsType, notificationsArr); //First Filter Category
    let finalfiltered = activeFiltering(activeFilter, particulate); //Active Second Filtering
    if (!!particulate & !!finalfiltered) {
      setNotifs(finalfiltered);
    }
  }, [notificationsArr, activeFilter, dispatch]);

  // Get notification count for each category
  useEffect(() => {
    if (!!notifs) {
      let notifsCountObj = getNotifsCount(notificationsArr);
      countNotifs(notifsCountObj);
    }
  }, [notificationsArr]);

  // Load Notifications from the Database & call Context API
  useEffect(() => {
    if (!!auth?.user?.identityId) {
      loadNotifications();
    }
  }, [auth?.user?.identityId]);
  console.log(auth);
  return (
    <>
      {isFetching ? (
        <div className="loading-notifications-skeleton">
          <Skeleton active />
          <br />
          <Skeleton active />
        </div>
      ) : (
        <>
          {" "}
          <div className={`notifs-list-container ${isDarkMode ? "dark" : ""}`}>
            {" "}
            <div className="notification-headr-container">
              <div className="notif-search-headr">
                <Input
                  onChange={onSearchCard}
                  className="kerko"
                  placeholder="Kërko..."
                />
              </div>
              <FilterHeader {...{ activeFilter, processActiveFilter }} />
            </div>
            {multiCheck.length > 0 && (
              <>
                <div className="selection-options-notifs">
                  {" "}
                  {multiCheck?.some(
                    (el) => el?.notificationMarkedRed === false
                  ) && (
                    <Popconfirm
                      classNames={{
                        root: `globalPopover ${isDarkMode ? "dark" : ""}`,
                      }}
                      title="A jeni të sigurt që dëshironi t'i shënoni si të lexuara?"
                      onConfirm={multiMarkRead}
                      okText="Po, shëno."
                      cancelText="Jo, anullo."
                    >
                      <button className="selection-btn">
                        Shëno si të lexuar
                      </button>{" "}
                    </Popconfirm>
                  )}
                  {multiCheck?.some(
                    (el) => el?.notificationMarkedRed === true
                  ) && (
                    <Popconfirm
                      classNames={{
                        root: `globalPopover ${isDarkMode ? "dark" : ""}`,
                      }}
                      title="A jeni të sigurt që dëshironi t'i shënoni si të palexuara?"
                      onConfirm={multiMarkUnread}
                      okText="Po, shëno."
                      cancelText="Jo, anullo."
                    >
                      <button className="selection-btn">
                        Shëno si të palexuar
                      </button>{" "}
                    </Popconfirm>
                  )}
                  <Popconfirm
                    classNames={{
                      root: `globalPopover ${isDarkMode ? "dark" : ""}`,
                    }}
                    title="A jeni të sigurt që dëshironi t'i fshihni nga lista kryesore?"
                    onConfirm={multiHide}
                    okText="Po, fshih."
                    cancelText="Jo, anullo."
                  >
                    {" "}
                    <button className="selection-btn">Fshih/Shfaq</button>{" "}
                  </Popconfirm>
                  <button className="selection-btn" onClick={selectAll}>
                    Selekto të gjitha
                  </button>{" "}
                  <button
                    className="selection-btn"
                    onClick={() => setMultiCheck([])}
                  >
                    Hiq Selektimin
                  </button>
                  <Popconfirm
                    classNames={{
                      root: `globalPopover ${isDarkMode ? "dark" : ""}`,
                    }}
                    title="A jeni të sigurt që dëshironi t'i fshini?"
                    onConfirm={multiDelete}
                    okText="Po, fshij."
                    cancelText="Jo, anullo."
                  >
                    {" "}
                    <button className="selection-btn">
                      Fshini Njoftim{multiCheck?.length > 1 ? "et" : "in"}
                    </button>{" "}
                  </Popconfirm>
                </div>
                <br />
              </>
            )}
            <ul className="notifs-list">
              {" "}
              {filterActive === false
                ? notifs
                    ?.slice(pagination.head, pagination.tail)
                    .map((n, idx) => (
                      <li key={idx} className="list-item">
                        <>
                          <div
                            className={`marker ${
                              !!multiCheck.find(
                                (el) => el?.notificationId === n.notificationId
                              )
                                ? "checked"
                                : ""
                            }`}
                          >
                            <Checkbox
                              checked={
                                !!multiCheck.find(
                                  (el) =>
                                    el?.notificationId === n.notificationId
                                )
                                  ? true
                                  : false
                              }
                              key={`${idx} item`}
                              onChange={(e) => onAddCheck(e.target.checked, n)}
                            />
                          </div>
                          <SingleNotif
                            // onClick={() => navigate(`${n.notificationUrl}`)}
                            handleCancel={handleCancel}
                            key={idx}
                            content={n}
                            {...{
                              deleteNotif,
                              markRead,
                              hideNotif,
                              toggleRead,
                            }}
                          />
                        </>
                      </li>
                    ))
                : searchTerm.map((n, idx) => (
                    <li key={idx} className="list-item">
                      <>
                        <div
                          className={`marker ${
                            !!multiCheck.find(
                              (el) => el?.notificationId === n.notificationId
                            )
                              ? "checked"
                              : ""
                          }`}
                        >
                          <Checkbox
                            checked={
                              !!multiCheck.find(
                                (el) => el?.notificationId === n.notificationId
                              )
                                ? true
                                : false
                            }
                            key={`${idx} item`}
                            onChange={(e) => onAddCheck(e.target.checked, n)}
                          />
                        </div>
                        <SingleNotif
                          // onClick={() => navigate(`${n.notificationUrl}`)}
                          handleCancel={handleCancel}
                          key={idx}
                          content={n}
                          {...{ deleteNotif, markRead, hideNotif, toggleRead }}
                        />
                      </>
                    </li>
                  ))}
            </ul>
            {searchTerm === null ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {" "}
                {pagination.tail < notifs.length && (
                  <span onClick={onPagination} style={{ cursor: "pointer" }}>
                    <UnfoldIcon />
                  </span>
                )}
              </div>
            ) : null}
            {notifs.length === 0 && isFetching === false ? (
              <p className="no-notifs">Nuk ka njoftime për të shfaqur!</p>
            ) : null}
          </div>
        </>
      )}
    </>
  );
}
export default NotificationList;
